'use client'

import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'

// Icons
const Shield = ({ className }) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
const Clock = ({ className }) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
const Star = ({ className }) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
const CheckCircle2 = ({ className }) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
const FileText = ({ className }) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/></svg>
const Calendar = ({ className }) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
const BookOpen = ({ className }) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>
const BarChart = ({ className }) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="20" x2="12" y2="10"/><line x1="18" y1="20" x2="18" y2="4"/><line x1="6" y1="20" x2="6" y2="16"/></svg>
const Heart = ({ className }) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg>
const Zap = ({ className }) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
const Target = ({ className }) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>
const ChevronRight = ({ className }) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
const Headphones = ({ className }) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 18v-6a9 9 0 0 1 18 0v6"/><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"/></svg>
const Play = ({ className }) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="5 3 19 12 5 21 5 3"/></svg>
const TrendingUp = ({ className }) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>
const Award = ({ className }) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/></svg>
const Sparkles = ({ className }) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/></svg>
const Activity = ({ className }) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
const Users = ({ className }) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
const Trophy = ({ className }) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/><path d="M4 22h16"/><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/><path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"/></svg>
const RefreshCw = ({ className }) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/><path d="M8 16H3v5"/></svg>
const Plus = ({ className }) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
const X = ({ className }) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
const Video = ({ className }) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m10 9 5 3-5 3z"/></svg>
const Book = ({ className }) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"/></svg>

// Activity type config
const ACTIVITY_TYPES = {
  video: { label: 'Video/Lecture', icon: Video, color: '#45D3FF' },
  practice: { label: 'Practice', icon: FileText, color: '#3AD29F' },
  reading: { label: 'Reading', icon: Book, color: '#9A7BFF' },
  study_group: { label: 'Study Group', icon: Users, color: '#F3B055' },
  project: { label: 'Project', icon: Target, color: '#FF6B6B' },
  other: { label: 'Other', icon: Clock, color: '#A8B0D9' }
}

// Log Hours Modal
function LogHoursModal({ course, onClose, onLog }) {
  const [activityType, setActivityType] = useState('video')
  const [hours, setHours] = useState('')
  const [description, setDescription] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!hours || parseFloat(hours) <= 0) return
    
    setLoading(true)
    setError(null)
    
    try {
      const res = await fetch('/api/hours/log', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          courseId: course.id,
          activityType,
          hours: parseFloat(hours),
          description
        })
      })
      
      const data = await res.json()
      if (!res.ok) throw new Error(data.error || 'Failed to log hours')
      
      onLog(data)
      onClose()
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="modal-overlay"
      onClick={onClose}
    >
      <motion.div
        initial={{ scale: 0.95, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.95, opacity: 0 }}
        className="modal-content"
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>Log Outside Learning</h3>
          <button className="btn-icon" onClick={onClose}><X className="w-5 h-5" /></button>
        </div>
        
        <p className="modal-subtitle">{course.courseName}</p>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Activity Type</label>
            <div className="activity-grid">
              {Object.entries(ACTIVITY_TYPES).map(([type, { label, icon: Icon, color }]) => (
                <button
                  key={type}
                  type="button"
                  className={`activity-btn ${activityType === type ? 'active' : ''}`}
                  style={{ '--accent': color }}
                  onClick={() => setActivityType(type)}
                >
                  <Icon className="w-4 h-4" />
                  <span>{label}</span>
                </button>
              ))}
            </div>
          </div>
          
          <div className="form-group">
            <label>Hours Spent</label>
            <input
              type="number"
              step="0.25"
              min="0.25"
              max="24"
              value={hours}
              onChange={e => setHours(e.target.value)}
              placeholder="e.g., 2.5"
              required
            />
          </div>
          
          <div className="form-group">
            <label>Description (optional)</label>
            <input
              type="text"
              value={description}
              onChange={e => setDescription(e.target.value)}
              placeholder="e.g., Watched Khan Academy videos"
            />
          </div>
          
          {error && <p className="error-message">{error}</p>}
          
          <button type="submit" className="btn-primary full-width" disabled={loading}>
            {loading ? 'Logging...' : `Log ${hours || '0'} Hours`}
          </button>
        </form>
      </motion.div>
    </motion.div>
  )
}

// Course Card Component
function CourseCard({ course, onLogHours }) {
  const progressPercent = course.progress.total > 0 
    ? (course.progress.completed / course.progress.total) * 100 
    : 0

  return (
    <div className="course-card glass-card">
      <div className="course-card-header">
        <div>
          <h3 className="course-name">{course.courseName}</h3>
          <p className="course-meta">{course.courseCode} • {course.instructor || 'TBD'} • {course.term}</p>
        </div>
        <div className="course-grade">
          <span className="grade-letter">{course.grade.letter || '—'}</span>
          {course.grade.percent && <span className="grade-percent">{course.grade.percent}%</span>}
        </div>
      </div>
      
      {/* Hours - THE KEY METRIC */}
      <div className="course-hours-display">
        <div className="hours-main">
          <span className="hours-number">{course.hours.total}</span>
          <span className="hours-label">hours invested</span>
        </div>
        <div className="hours-breakdown-bar">
          <div className="hours-bar-track">
            <div 
              className="hours-bar-canvas" 
              style={{ width: `${course.hours.total > 0 ? (course.hours.canvas / course.hours.total) * 100 : 0}%` }}
            />
            <div 
              className="hours-bar-outside"
              style={{ width: `${course.hours.total > 0 ? (course.hours.outside / course.hours.total) * 100 : 0}%` }}
            />
          </div>
          <div className="hours-legend">
            <span><span className="dot canvas" /> Canvas: {course.hours.canvas}h</span>
            <span><span className="dot outside" /> Outside: {course.hours.outside}h</span>
          </div>
        </div>
      </div>
      
      {/* Competencies */}
      {course.competencies.length > 0 && (
        <div className="course-competencies">
          {course.competencies.slice(0, 3).map(c => (
            <span key={c.id} className="competency-tag">{c.name}</span>
          ))}
          {course.competencies.length > 3 && (
            <span className="competency-more">+{course.competencies.length - 3}</span>
          )}
        </div>
      )}
      
      {/* Actions */}
      <div className="course-actions">
        <button className="btn-log" onClick={() => onLogHours(course)}>
          <Plus className="w-4 h-4" /> Log Hours
        </button>
        {course.verification?.hash && (
          <Link to={`/verify/${course.verification.hash}`} className="btn-verify">
            <Shield className="w-4 h-4" /> Verify
          </Link>
        )}
      </div>
    </div>
  )
}

// Main Dashboard
export default function Dashboard() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [syncing, setSyncing] = useState(false)
  const [error, setError] = useState(null)
  const [activeTab, setActiveTab] = useState('overview')
  const [logModalCourse, setLogModalCourse] = useState(null)

  useEffect(() => {
    loadDashboard()
    autoSync()
  }, [])

  const loadDashboard = async () => {
    try {
      const res = await fetch('/api/dashboard')
      if (!res.ok) throw new Error('Failed to load dashboard')
      const result = await res.json()
      
      // Also fetch holistic moments
      try {
        const momentsRes = await fetch('/api/moments/generate', { method: 'POST' })
        if (momentsRes.ok) {
          const momentsData = await momentsRes.json()
          result.moments = momentsData.moments
          result.effortBand = momentsData.effortBand
          result.recovery = momentsData.recovery
        }
      } catch (e) {
        console.log('Moments fetch skipped:', e)
      }
      
      setData(result)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  const autoSync = async () => {
    try {
      const lastSync = localStorage.getItem('lastCanvasSync')
      const oneHourAgo = Date.now() - (60 * 60 * 1000)
      
      if (!lastSync || parseInt(lastSync) < oneHourAgo) {
        console.log('Auto-syncing Canvas...')
        const res = await fetch('/api/canvas/sync', { method: 'POST' })
        if (res.ok) {
          localStorage.setItem('lastCanvasSync', Date.now().toString())
          loadDashboard()
        }
      }
    } catch (e) {
      console.log('Auto-sync skipped:', e)
    }
  }

  const syncCanvas = async () => {
    setSyncing(true)
    try {
      const res = await fetch('/api/canvas/sync', { method: 'POST' })
      const result = await res.json()
      if (!res.ok) throw new Error(result.error || 'Sync failed')
      localStorage.setItem('lastCanvasSync', Date.now().toString())
      await loadDashboard()
    } catch (err) {
      setError(err.message)
    } finally {
      setSyncing(false)
    }
  }

  const handleLogHours = () => {
    loadDashboard()
  }

  if (loading) {
    return (
      <div className="dashboard-loading">
        <div className="loading-bar">
          <div className="loading-fill" />
        </div>
        <p>Preparing your journey...</p>
      </div>
    )
  }

  if (error) {
    return (
      <div className="dashboard-error">
        <p>Error: {error}</p>
        <button onClick={loadDashboard} className="btn-primary">Retry</button>
      </div>
    )
  }

  const userName = data?.user?.name?.split(' ')[0] || 'Learner'

  return (
    <div className="student-dashboard">
      {/* Header */}
      <header className="dashboard-header">
        <div>
          <h1>Welcome back, {userName}!</h1>
          <p className="header-subtitle">Your journey to proven competence continues</p>
        </div>
        <button 
          className={`btn-sync ${syncing ? 'syncing' : ''}`}
          onClick={syncCanvas}
          disabled={syncing}
        >
          <RefreshCw className="w-4 h-4" />
          {syncing ? 'Syncing...' : 'Sync Canvas'}
        </button>
      </header>

      {/* Journey Hero Card */}
      <div className="hero-card glass-card">
        <div className="hero-glow hero-glow-1" />
        <div className="hero-glow hero-glow-2" />
        
        <div className="hero-content">
          <div className="hero-main">
            <div className="hero-status">
              <span className="status-dot" />
              <span>You Are Here</span>
            </div>
            <h2 className="hero-title">Your Learning Journey</h2>
            <p className="hero-desc">
              You've invested <strong>{data?.summary?.totalHoursInvested || 0} hours</strong> across {data?.summary?.activeCourses || 0} active courses, 
              developing {data?.summary?.competenciesCount || 0} verified competencies.
            </p>
          </div>
          <div className="hero-trophy">
            <Trophy className="w-12 h-12" />
          </div>
        </div>
        
        {/* Stats Row */}
        <div className="hero-stats">
          <div className="hero-stat">
            <div className="stat-icon"><Clock className="w-4 h-4" /></div>
            <div className="stat-content">
              <span className="stat-value">{data?.summary?.totalHoursInvested || 0}</span>
              <span className="stat-label">Hours Invested</span>
            </div>
          </div>
          <div className="hero-stat">
            <div className="stat-icon"><Shield className="w-4 h-4" /></div>
            <div className="stat-content">
              <span className="stat-value">{data?.summary?.competenciesCount || 0}</span>
              <span className="stat-label">Competencies</span>
            </div>
          </div>
          <div className="hero-stat">
            <div className="stat-icon"><BookOpen className="w-4 h-4" /></div>
            <div className="stat-content">
              <span className="stat-value">{data?.summary?.activeCourses || 0}</span>
              <span className="stat-label">Active Courses</span>
            </div>
          </div>
          <div className="hero-stat">
            <div className="stat-icon"><Heart className="w-4 h-4" /></div>
            <div className="stat-content">
              <span className="stat-value">{data?.recovery || data?.wellness?.recovery || '—'}%</span>
              <span className="stat-label">Recovery</span>
            </div>
          </div>
        </div>
      </div>

      {/* AI Recommendations - Holistic */}
      <section className="recommendations-section">
        <div className="section-header">
          <h2><Sparkles className="w-5 h-5" /> AI-Powered Recommendations</h2>
          {data?.effortBand && (
            <span className={`effort-badge ${data.effortBand.band}`}>
              {data.effortBand.label} • {data.recovery}% Recovery
            </span>
          )}
        </div>
        
        <div className="recommendations-grid">
          {/* Do Now */}
          <div className="rec-card rec-now">
            <div className="rec-header">
              <Zap className="w-4 h-4" />
              <span>Do Now</span>
            </div>
            <div className="rec-content">
              {data?.moments?.now?.length > 0 ? (
                data.moments.now.slice(0, 3).map((m, i) => (
                  <div key={m.id || i} className="rec-item">
                    <h4>{m.icon || '📌'} {m.title}</h4>
                    <p>{m.description}</p>
                  </div>
                ))
              ) : (
                <div className="rec-item">
                  <h4>You're all caught up!</h4>
                  <p>No urgent tasks right now</p>
                </div>
              )}
            </div>
          </div>
          
          {/* Up Next */}
          <div className="rec-card rec-next">
            <div className="rec-header">
              <ChevronRight className="w-4 h-4" />
              <span>Up Next</span>
            </div>
            <div className="rec-content">
              {data?.moments?.next?.length > 0 ? (
                data.moments.next.slice(0, 3).map((m, i) => (
                  <div key={m.id || i} className="rec-item">
                    <h4>{m.icon || '📋'} {m.title}</h4>
                    <p>{m.description}</p>
                  </div>
                ))
              ) : (
                <div className="rec-item">
                  <h4>No upcoming tasks</h4>
                  <p>Great time to log outside learning!</p>
                </div>
              )}
            </div>
          </div>
          
          {/* Plan Ahead */}
          <div className="rec-card rec-later">
            <div className="rec-header">
              <Calendar className="w-4 h-4" />
              <span>Plan Ahead</span>
            </div>
            <div className="rec-content">
              {data?.moments?.later?.length > 0 ? (
                data.moments.later.slice(0, 3).map((m, i) => (
                  <div key={m.id || i} className="rec-item">
                    <h4>{m.icon || '🎯'} {m.title}</h4>
                    <p>{m.description}</p>
                  </div>
                ))
              ) : (
                <>
                  <div className="rec-item">
                    <h4>✏️ Log outside learning</h4>
                    <p>Videos, reading, study groups - it all counts!</p>
                  </div>
                  <div className="rec-item">
                    <h4>🔍 Review your progress</h4>
                    <p>Check Skills Ledger and verify credentials</p>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Tabs */}
      <div className="tabs-container">
        <div className="tabs-list">
          <button 
            className={`tab ${activeTab === 'overview' ? 'active' : ''}`}
            onClick={() => setActiveTab('overview')}
          >
            <Activity className="w-4 h-4" /> Overview
          </button>
          <button 
            className={`tab ${activeTab === 'courses' ? 'active' : ''}`}
            onClick={() => setActiveTab('courses')}
          >
            <BookOpen className="w-4 h-4" /> Courses
          </button>
          <button 
            className={`tab ${activeTab === 'competencies' ? 'active' : ''}`}
            onClick={() => setActiveTab('competencies')}
          >
            <Shield className="w-4 h-4" /> Skills Ledger
          </button>
          <button 
            className={`tab ${activeTab === 'performance' ? 'active' : ''}`}
            onClick={() => setActiveTab('performance')}
          >
            <TrendingUp className="w-4 h-4" /> Performance
          </button>
        </div>
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {/* Overview Tab */}
        {activeTab === 'overview' && (
          <div className="tab-overview">
            {/* Hours Summary */}
            <div className="overview-hours glass-card">
              <h3><Clock className="w-5 h-5" /> Hours Invested This Term</h3>
              <div className="hours-summary">
                <div className="hours-total-big">
                  <span className="number">{data?.summary?.totalHoursInvested || 0}</span>
                  <span className="label">total hours</span>
                </div>
                <div className="hours-split">
                  <div className="split-item canvas">
                    <span className="split-value">{data?.summary?.canvasHours || 0}</span>
                    <span className="split-label">Canvas</span>
                  </div>
                  <span className="split-plus">+</span>
                  <div className="split-item outside">
                    <span className="split-value">{data?.summary?.outsideHours || 0}</span>
                    <span className="split-label">Outside</span>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Quick Course List */}
            <div className="overview-courses">
              <h3>Active Courses</h3>
              <div className="courses-quick-list">
                {data?.courses?.filter(c => c.status === 'active').slice(0, 4).map(course => (
                  <div key={course.id} className="course-quick glass-card">
                    <div className="course-quick-info">
                      <h4>{course.courseName}</h4>
                      <p>{course.hours.total} hours • {course.grade.letter || 'N/A'}</p>
                    </div>
                    <button className="btn-sm" onClick={() => setLogModalCourse(course)}>
                      <Plus className="w-3 h-3" />
                    </button>
                  </div>
                ))}
                {(!data?.courses || data.courses.filter(c => c.status === 'active').length === 0) && (
                  <div className="empty-state-small">
                    <p>No active courses. Click "Sync Canvas" to import.</p>
                  </div>
                )}
              </div>
            </div>
            
            {/* Wellness (if connected) */}
            {data?.wellness && (
              <div className="overview-wellness glass-card">
                <h3><Heart className="w-5 h-5" /> Wellbeing Insights</h3>
                <div className="wellness-grid">
                  <div className="wellness-stat">
                    <span className="wellness-value green">{data.recovery || data.wellness.recovery}%</span>
                    <span className="wellness-label">Recovery</span>
                  </div>
                  <div className="wellness-stat">
                    <span className="wellness-value cyan">{data.wellness.sleepHours?.toFixed(1) || '—'}</span>
                    <span className="wellness-label">Sleep (hrs)</span>
                  </div>
                  <div className="wellness-stat">
                    <span className={`wellness-band ${data.effortBand?.band || 'moderate'}`}>
                      {data.effortBand?.label || 'Moderate'}
                    </span>
                    <span className="wellness-label">Effort Band</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Courses Tab */}
        {activeTab === 'courses' && (
          <div className="tab-courses">
            {data?.courses?.filter(c => c.status === 'active').map(course => (
              <CourseCard 
                key={course.id} 
                course={course} 
                onLogHours={setLogModalCourse}
              />
            ))}
            {(!data?.courses || data.courses.filter(c => c.status === 'active').length === 0) && (
              <div className="empty-state">
                <BookOpen className="w-12 h-12" />
                <p>No active courses found. Sync with Canvas to get started!</p>
                <button className="btn-primary" onClick={syncCanvas}>
                  <RefreshCw className="w-4 h-4" /> Sync Canvas
                </button>
              </div>
            )}
          </div>
        )}

        {/* Skills Ledger Tab */}
        {activeTab === 'competencies' && (
          <div className="tab-competencies">
            <div className="ledger-header glass-card">
              <div className="ledger-info">
                <h3><Shield className="w-5 h-5" /> Verified Skills Ledger</h3>
                <p>Cryptographically verified competencies from your learning journey</p>
              </div>
              <Link to="/verify" className="btn-secondary">
                <Shield className="w-4 h-4" /> Public Verification
              </Link>
            </div>
            
            <div className="competencies-grid">
              {data?.competencies?.map(comp => (
                <div key={comp.id} className="competency-card glass-card">
                  <div className="comp-header">
                    <h4>{comp.name}</h4>
                    <span className="comp-category">{comp.category}</span>
                  </div>
                  <div className="comp-hours">
                    <span className="comp-hours-value">{comp.totalHours}</span>
                    <span className="comp-hours-label">hours</span>
                  </div>
                  <div className="comp-bar">
                    <div 
                      className="comp-bar-fill" 
                      style={{ width: `${Math.min(100, (comp.totalHours / 50) * 100)}%` }}
                    />
                  </div>
                </div>
              ))}
            </div>
            
            {(!data?.competencies || data.competencies.length === 0) && (
              <div className="empty-state">
                <Shield className="w-12 h-12" />
                <p>No competencies yet. Start logging hours to build your skills!</p>
              </div>
            )}
          </div>
        )}

        {/* Performance Tab */}
        {activeTab === 'performance' && (
          <div className="tab-performance">
            <div className="performance-header glass-card">
              <h3><Award className="w-5 h-5" /> Performance Dashboard</h3>
              <p>Track your progress across all courses. Your verified credentials build a portable, tamper-evident portfolio.</p>
            </div>
            
            <div className="performance-stats">
              <div className="perf-stat glass-card">
                <CheckCircle2 className="w-6 h-6 green" />
                <span className="perf-value green">
                  {data?.courses?.length > 0 
                    ? Math.round(data.courses.reduce((acc, c) => acc + (c.progress?.percent || 0), 0) / data.courses.length)
                    : 0}%
                </span>
                <span className="perf-label">Avg Completion</span>
              </div>
              <div className="perf-stat glass-card">
                <Clock className="w-6 h-6 cyan" />
                <span className="perf-value cyan">{data?.summary?.totalHoursInvested || 0}</span>
                <span className="perf-label">Total Hours</span>
              </div>
              <div className="perf-stat glass-card">
                <Shield className="w-6 h-6 purple" />
                <span className="perf-value purple">{data?.summary?.competenciesCount || 0}</span>
                <span className="perf-label">Competencies</span>
              </div>
            </div>
            
            {/* Course Progress */}
            <div className="performance-courses glass-card">
              <h4>Course Progress</h4>
              <div className="progress-list">
                {data?.courses?.map(course => (
                  <div key={course.id} className="progress-item">
                    <div className="progress-info">
                      <span className="progress-name">{course.courseName}</span>
                      <span className="progress-hours">{course.hours.total}h</span>
                    </div>
                    <div className="progress-bar">
                      <div 
                        className="progress-fill" 
                        style={{ width: `${course.progress?.percent || 0}%` }}
                      />
                    </div>
                    <span className="progress-percent">{course.progress?.percent || 0}%</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Log Hours Modal */}
      <AnimatePresence>
        {logModalCourse && (
          <LogHoursModal
            course={logModalCourse}
            onClose={() => setLogModalCourse(null)}
            onLog={handleLogHours}
          />
        )}
      </AnimatePresence>
    </div>
  )
}
